<div class="card-container">
  <mwp-table [tableColumns]="tableColumns" [dataSource]="tableData" header="{{ header }}" [isModal]="isModal" />
  @if (displayCloseButton) {
  <div class="d-inline-flex w-100 justify-content-center mt-3 mb-1">
    <button class="mwp-button-secondary" (click)="close()">
      <mwp-text-translate text="Close" jsonKey="close" />
    </button>
  </div>
  }
</div>